import PropTypes from 'prop-types';
import AnimateOnScroll from '../components/AnimateOnScroll';
import Logo from '../components/Logo';
import { useLanguage } from '../providers/LanguageProvider';


const Contact = ({ id }) => {
    const { translations } = useLanguage();
    
    return (
        <section id={id} className="bg-contact_dark py-12 md:py-20">
            <div className="flex flex-col items-center justify-center gap-12 text-center">
                <AnimateOnScroll>
                  <h2 className="text-2xl md:text-3xl font-bold text-white text-center">{translations.contact.title}</h2>
                </AnimateOnScroll>
                <AnimateOnScroll delay={300}>
                  <a href="tel:+972546638138" className="bg-white text-black px-6 py-2">{translations.contact.button}</a>
                </AnimateOnScroll>

                <AnimateOnScroll delay={600}>
                  <div className="mx-auto max-w-[1150px] text-center">
                    <Logo variant="light" />
                  </div>
                </AnimateOnScroll>

            </div>
        </section>
    )
}

Contact.propTypes = {
  id: PropTypes.string,
};

export default Contact;